import { restApiDP } from "@plannel/services/utils/rest-api";

const getTrackingSearch = (params) => {
  return restApiDP.get("/api/dp-tracking/version", { params });
};
const getTrackingData = (data) => {
  return restApiDP.post("/api/dp-tracking-data", data);
};

const dpTrackingReportService = {
  getTrackingSearch,
  getTrackingData
};

export default dpTrackingReportService;